import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';

const objectType = 'service-requests';

class ServiceRequestsService extends BaseService {

  static getList(page) {

    return super.get(`service_requests?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static search(search, page) {

    return super.get(`service_requests/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`service_requests/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['service-requests'][object.result['service-requests'][0]];
        data.adulticides = object.entities.adulticides;
        data.larvicides = object.entities.larvicides;
        data = camelizeKeys(data);
        data = dates.datepickerFormat(data, ['observedDate']);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.post(objectType, `service_requests`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.patch(objectType, `service_requests/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`service_requests/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default ServiceRequestsService;